module.exports = __webpack_public_path__ + "img/clothing-transfer.5cf542c4.png";